
import { useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  Paper,
  Tab,
  Tabs,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import { useFormikContext } from "formik";
import ClienteTabGeral from "./cliente-tab-geral";
import ClienteTabEnderecoPrincipal from "./cliente-tab-endereco-principal";
import ClienteTabEnderecoEntrega from "./cliente-tab-endereco-entrega";
import { ClienteContext } from "../../contexts/clientes-context";
import ClienteTabEmail from "./cliente-tab-emails";
import ClientTabCondicoesVenda from "./cliente-tab-condicoes-venda";
import ClientTabNotasGerais from "./cliente-tab-notas-gerais";
import ClientTabEnderecoCobranca from "./cliente-tab-endereco-cobranca";
import { ClientePainel } from "./cliente-painel";
import ClienteTabDadosAdicionais from "./cliente-tab-dados-adicionais";

export default function ClienteTabs() {

  const theme = useTheme();

  const screenWidth = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    constantes,
    tabValue,
    setTab,
    fecharMenu,
    somenteLeitura
  } = useContext(ClienteContext)

  const [abasVisiveis, setAbasVisiveis] = useState();

  const formik = useFormikContext();
  const { values, errors, isSubmitting, submitCount } = formik;

  const lastNavigatedSubmitCount = useRef(0);

  function selecionarTab(event, newValue) {
    setTab(newValue);
    fecharMenu();
  }

  function getAbasVisiveis(cliente, errors) {
    return [
      {
        id: 0,
        name: "Geral",
        label: constantes.Geral,
        visible: true,
        color: !somenteLeitura && (errors?.Entidade?.CpfCnpj ||
          errors?.Entidade?.DataNascimentoFundacao ||
          errors?.Entidade?.Nome)
           ? "red" : "#007767",
        element: <ClienteTabGeral />
      },
      {
        id: 1,
        name: "EnderecoPrincipal",
        label: constantes.EnderecoPrincipal,
        visible: true,
        color: !somenteLeitura && errors?.EnderecoPrincipal ? "red" : "#007767",
        element: <ClienteTabEnderecoPrincipal />
      },
      {
        id: 2,
        name: "EnderecoEntrega",
        label: constantes.EnderecodeEntrega,
        visible: true,
        color: !somenteLeitura && errors?.EnderecoEntrega ? "red" : "#007767",
        element: <ClienteTabEnderecoEntrega />
      },
      {
        id: 3,
        name: "EnderecoCobrança",
        label: constantes.EnderecodeCobranca,
        visible: true,
        color: !somenteLeitura && errors?.EnderecoCobrança ? "red" : "#007767",
        element: <ClientTabEnderecoCobranca />
      },
      {
        id: 4,
        name: "Emails",
        label: constantes.Emails,
        visible: true,
        color: !somenteLeitura && temErroEmails ? "red" : "#007767",
        element: <ClienteTabEmail />
      },
      {
        id: 5,
        name: "DadosAdicionais",
        label: constantes.DadosAdicionais,
        visible: true,
        color: !somenteLeitura && errors?.DadosAdicionais ? "red" : "#007767",
        element: <ClienteTabDadosAdicionais />
      },

      {
        id: 6,
        name: "CondicoesVenda",
        label: constantes.CondicoesdeVenda,
        visible: true,
        color: !somenteLeitura && errors?.CondicoesVenda ? "red" : "#007767",
        element: <ClientTabCondicoesVenda />
      },
      {
        id: 7,
        name: "NotasGerais",
        label: constantes.NotasGerais,
        visible: true,
        color: !somenteLeitura && errors?.NotasGerais ? "red" : "#007767",
        element: <ClientTabNotasGerais />
      }
    ]
  }

  useEffect(() => {
    setAbasVisiveis(getAbasVisiveis(values, errors));
  }, [values])


  useEffect(() => {
    if (submitCount === 0) return;
    if (submitCount <= lastNavigatedSubmitCount.current) return;

    const temErroEmailsLocal = Array.isArray(errors?.Entidade?.Emails) &&
      errors.Entidade.Emails.some(item => item?.Destino || item?.Email);

    // Cada posição corresponde ao id da tab em getAbasVisiveis (0=Geral, 1=EnderecoPrincipal, ...)
    const errosPorAba = [
      !!(errors?.Geral || errors?.Entidade?.CpfCnpj || errors?.Entidade?.DataNascimentoFundacao || errors?.Entidade?.Nome),
      !!errors?.EnderecoPrincipal,
      !!errors?.EnderecoEntrega,
      !!errors?.EnderecoCobrança,
      !!temErroEmailsLocal,
      !!errors?.DadosAdicionais,
      !!(errors?.CondicoesVenda || errors?.DestinoOperacao),
      !!errors?.NotasGerais,
    ];

    const primeiraAbaComErro = errosPorAba.findIndex(Boolean);
    if (primeiraAbaComErro !== -1) {
      setTab(primeiraAbaComErro);
      lastNavigatedSubmitCount.current = submitCount;
    }
  }, [submitCount, errors])

  const temErroEmails = Array.isArray(errors?.Entidade?.Emails) &&
  errors.Entidade.Emails.some(
    (item) => item?.Destino || item?.Email
  );


  return (
    <>
      <Box>
        <Box padding={{ xs: 1, sm: 1.5, md: 2 }}>
          {!screenWidth && (
            <Box width="100%" height={{ xs: 60, sm: 65, md: 70 }} component={Paper} mb={{ xs: 2, sm: 2.5, md: 3 }}>
              <Tabs
                value={tabValue}
                onChange={selecionarTab}
                aria-label="Tabs"
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
                textColor={"#007767"}
                TabIndicatorProps={{
                  style: { backgroundColor: "#007767" },
                }}
              >
                {abasVisiveis && abasVisiveis.filter((item, index) => {
                  return item.visible
                }).map((item, index) => {
                  return <Tab name={item.name} label={item.label} sx={{ color: item.color }} />
                })}
              </Tabs>
            </Box>
          )}

          {abasVisiveis && abasVisiveis.filter((item, index) => {
            return item.visible
          }).map((item, index) => {
            return (
              <ClientePainel value={tabValue} index={index}>
                {item.element}
              </ClientePainel>
            )
          })}
        </Box>
      </Box>
    </>
  );
};